<template>
  <span class="c-bullet-between">
    <slot/>
  </span>
</template>

<style lang="scss">
  .c-bullet-between > *:not(:first-child)::before {
    content: '\2022';
    margin: 0 0.25em;
    display: inline-block;
  }
</style>
